/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback } from 'react';

import { useSetAtom } from 'jotai';

import { jsx } from '@atlaskit/css';

import { type MessageRole } from '../../../../../../../contexts/AsideContext';
import { ExecuteQueryAtom } from '../../../../../../../state/ExecuteActionAtom';
import { CypherQueryAtom } from '../../../../../../../state/LabsAtoms';
import { PushQueryHistoryAtom } from '../../../atoms/historyAtoms';
import { ChatMessageView } from './ChatMessageView';

export type ChatMessageProps = {
	messageRole: MessageRole;
	content: string;
	isLoading?: boolean;
	rawCypherQuery?: string;
	assistantName?: string;
	onUseCypher?: (query: string) => void;
};

export const ChatMessage = ({
	messageRole,
	content,
	isLoading = false,
	rawCypherQuery,
	assistantName,
	onUseCypher,
}: ChatMessageProps): JSX.Element => {
	const setCypherQuery = useSetAtom(CypherQueryAtom);
	const executeQuery = useSetAtom(ExecuteQueryAtom);
	const pushQueryHistory = useSetAtom(PushQueryHistoryAtom);

	const handleUseCypher = useCallback(() => {
		if (rawCypherQuery) {
			if (onUseCypher) {
				onUseCypher(rawCypherQuery);
				return;
			}
			pushQueryHistory(rawCypherQuery);
			setCypherQuery(rawCypherQuery);
			executeQuery('none');
		}
	}, [rawCypherQuery, setCypherQuery, executeQuery, pushQueryHistory, onUseCypher]);

	return (
		<ChatMessageView
			messageRole={messageRole}
			content={content}
			isLoading={isLoading}
			rawCypherQuery={rawCypherQuery}
			assistantName={assistantName}
			onUseCypher={rawCypherQuery ? handleUseCypher : undefined}
		/>
	);
};
